import { createGlobalStyle } from 'styled-components';
import playBtn from './imgs/svgs/playBtn.svg';

export const GlobalStyle = createGlobalStyle`
   :root{
        /* COLORS */ 
       --primary: #F68500;
       --secondary: #DB056B;
       --nightBlue: #101E26;
       --thunderCloudGrey: #657985;
       --cloudGrey: #C5D6DF;
       --white: #ffffff;
       --black:#000000;

       --success: #90C540;
       --error: #EE3A33;

       --gradient: to right,#DB056B,  #F68500; 

       /* TYPE */
       --main-font: 'Roboto', sans-serif;
       --baseSize: 16px;
       --small: .75rem;

       /* SPACING */
       --global-width: 1024px;
       --global-margin: 2rem;
       --global-padding: 2rem;
   }

   *{
       box-sizing: border-box;
       margin: 0;
       padding: 0;
   }
    body{
         height: 100vh;
         font-size: var(--baseSize);
         font-family: var(--main-font);
         line-height: 1.2;
         color: var(--nightBlue)
    }


    h1, h2, h3, h4, h5, p, li{
        margin-bottom: 1rem;
    }

    h1{
        font-size: 3rem;
    }

    h2{
        font-size: 2.5rem;
    }

    h3{
        font-size: 2rem;
    }

    h4{
        font-size: 1.5rem;
    }

    h5{
        font-size:1rem;
    }

    p, li{
        line-height: 1.5rem;
    }

    a:link, a:visited{
        color: var(--primary);
        text-decoration: none;
        font-size: var(--small);
        font-weight: 900;
        letter-spacing:1px;
         &:hover{
            color:var(--secondary)
        }
    }

    /* BUTTON STYLE */
    button.btn{
        text-transform:uppercase;
        border: none;
        height:3rem;
        padding: 0 1.5rem;
        border-radius: 4rem;
        background: url(${playBtn}), linear-gradient(var(--gradient));
        background-position: 88% center;
        background-repeat: no-repeat;
        background-size: 1.2rem, 100%;
        font-weight: bold;
        color: var(--white);
        min-width: 14rem;
        text-align:left;
        transition: background-position .3s ease;
        cursor: pointer;
        letter-spacing: 1px;

     
        &:hover{
         background-position: 93% center;
        }
        
    }

    button.round, .round{
        height: 1.5rem;
        width:1.5rem;
        border-radius: 5rem;
        border:none;
        display:flex;
        align-items:center;
        justify-content:center;
        cursor:pointer;
        transition: transform .3s ease;
        &:last-child{
            margin-left: .5rem;
        }
        img{
            height:.75rem;
        }

        &:hover{
            transform: scale(1.1);
        }
    }
    button.addBtn{
        background-color: var(--primary)
    }
    button.removeBtn{
        background-color: var(--thunderCloudGrey);
         img{
            height:1rem;
        }
    }
    button.playBtn{
        background-color: var(--secondary)
    }
    button.addBtnLg{
        margin-left: 1rem;
        cursor:pointer;
        background-color: transparent;
        color: var(--white);
        border:none;
        display: flex;
        align-items:center;
        span.round{
            margin-right: .5rem;
            background-color: var(--primary);
        }
    }

    button.loginBtn{
        border:none;
        background-color: transparent;
        padding: .5rem;
        color:var(--primary);
        font-size: var(--small);
        font-weight: 700;
        letter-spacing:1px;
        cursor: pointer;
        text-transform:uppercase;

        &:hover{
            color:var(--secondary)
        }
    }

    /* CONTAINER STYLE */

    .app-wrapper{
        height: 100vh;

        .section-heading{
             text-align:  center ;
              margin:  4rem auto 0 auto ;
        }
    }


    .container{
        margin: 0 auto;
        padding: calc(var(--global-padding) * 2)  calc(var(--global-padding) * 2) 0 calc(var(--global-padding) * 2);
        position: relative;
    }

    .dark {
        background-color: var(--nightBlue);
        border-image: linear-gradient(var(--gradient)) 1;
        border-bottom: .5rem solid;
        h4, h5{
            color: var(--white);
        }
     }

     .block-wrapper{
        min-height: 60vh;
         display: flex;
         flex-wrap: wrap;
         justify-content:space-evenly;
         padding: calc( var(--global-padding) * 2);
         padding-top:1rem;
     }

     .page-container{
         height: 70vh;
        
        .message{
            text-align: center;
            margin: 5rem auto;
           width: 50%;
        }

     }
`;
